module.exports = __webpack_public_path__ + "img/three-part-active.80b16a0e.png";